<div *ngIf="benefit" class="main-container">
  <div class="banner-container">
    <div class="banner" [style.background-image]="'linear-gradient(180deg, rgba(0,0,0,0) 0%, #000 113.64%), url(' + benefit.photo + ')'">
      <div class="banner-description">
        <img src="{{ benefit.partner.logo }}" />
        <div class="benefit-description">
          <ng-container *ngIf="benefit.typete != '$'">
            <div class="benefitBox">
              <p>{{ benefit.category.name }}</p>
              <span
                >{{ benefit.discount }}{{ benefit.typete }}
                {{ benefit.benefit_discount }}</span
              >
            </div>
          </ng-container>
          <ng-container *ngIf="benefit.typete == '$'">
            <div class="benefitBox">
              <p>{{ benefit.category.name }}</p>
              <span
                >{{ benefit.typete }}{{ benefit.discount }}
                {{ benefit.benefit_discount }}</span
              >
            </div>
          </ng-container>
          <p class="description">{{ benefit.description }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="info-container">
    <div class="main-info">
      <div class="interaction-benefit">
        <div class="info-benefit">
          <div class="benefit-first">
            <div class="benefit-box">
              <img src="../../../assets/icon/icon-date.svg" alt="" />
              <div class="item-description">
                <p>Usalo los días</p>
                <div class="benefit-days">
                  <span
                    *ngFor="let day of weekDays"
                    [ngClass]="{
                      'active-day': activeDays.includes(day.value),
                      'inactive-day': !activeDays.includes(day.value)
                    }"
                  >
                    {{ day.label }}
                  </span>
                </div>
              </div>
            </div>
            <div class="benefit-box">
              <img src="../../../assets/icon/icon-vigency.svg" alt="" />
              <div class="item-description">
                <p>Vigencia</p>
                <span class="valid-days"
                  >desde {{ formatDate(benefit.date_from) }} hasta
                  {{ formatDate(benefit.date_to) }}</span
                >
              </div>
            </div>
            <div class="benefit-box">
              <img src="../../../assets/icon/icon-use.svg" alt="" />
              <div class="item-description">
                <p>Modalidad de uso</p>
                <div class="diff-types">
                  <span
                    class="item-type"
                    *ngFor="let type of benefit.benefit_type.split('-')"
                  >
                    {{ type | capitalize }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="benefit-second"
          >
            <div class="benefit-box" *ngIf="
              benefit.url !== 'null' && benefit.benefit_type !== 'PRESENCIAL'
            ">
              <img src="../../../assets/icon/icon-link.svg" alt="" />
              <div class="item-description">
                <p>Tienda online</p>
                <a href="{{ benefit.url }}" target="_blank">{{
                  benefit.url
                }}</a>
              </div>
            </div>
            <div class="benefit-box" *ngIf="benefit.benefit_type !== 'ONLINE'">
              <img src="../../../assets/icon/icon-local.svg" alt="" />
              <div class="item-description">
                <p>Sucursales adheridos</p>
                <a (click)="openBranchesModal()">Ver listado</a>
              </div>
            </div>
          </div>
        </div>
        <button
          id="btn_get_code"
          *ngIf="(benefit.codes_left > 0 || esCencosud) && benefit.redeemCodes"
          (click)="handleModal()"
        >
          {{ getWantMyCodeText() }}
        </button>
        <button
          *ngIf="
            benefit.codes_left == 0 &&
            !esCencosud &&
            !esEasy &&
            benefit.redeemCodes
          "
        >
          Este beneficio no posee códigos disponibles
        </button>
      </div>
      <div class="right">
        <ng-container *ngIf="benefit.benefit_type !== 'ONLINE'">
          <div class="map-area" id="sucursales">
            <div #mapContainer id="map"></div>
          </div>
        </ng-container>

        <ng-container *ngIf="benefit.benefit_type === 'ONLINE'">
          <img
            class="type-online"
            src="../../../assets/images/Mapa.png"
            alt=""
          />
        </ng-container>
      </div>
    </div>
    <hr />
    <div class="legal-container">
      <span class="legal-title">Legales</span>
      <p class="legals-text">{{ benefit.legales }}</p>
    </div>
  </div>

  <ng-container *ngIf="showModal">
    <div class="main-modal-container">
      <div class="modal-box">
        <button
          (click)="this.showModal = false"
          class="close btn-close"
        ></button>
        <p class="main-text">¡Felicitaciones {{ name }}!</p>
        <p class="enjoy-text">Podés disfrutar tu descuento Shell Box en</p>
        <div class="brand-container">
          <img [src]="benefit.partner.logo" />
          <ng-container *ngIf="benefit.typete !== '$'">
            <div>
              <div class="category-exchange">
                <p>{{ benefit.category.name }}</p>
                <div *ngIf="benefit.benefit_type !== 'ONLINE-PRESENCIAL'">
                  <img
                    class="type-image"
                    [src]="getBenefitTypeImage(benefit.benefit_type)"
                    alt=""
                  />
                  <span class="item-type">{{
                    benefit.benefit_type | capitalize
                  }}</span>
                </div>
              </div>
              <span>{{ benefit.discount }}{{ benefit.typete }}</span>
              <p>{{ benefit.benefit_discount }}</p>
            </div>
          </ng-container>
          <ng-container *ngIf="benefit.typete === '$'">
            <div>
              <div class="category-exchange">
                <p>{{ benefit.category.name }}</p>
                <div>
                  <img
                    class="type-image"
                    [src]="getBenefitTypeImage(benefit.benefit_type)"
                    alt=""
                  />
                  <span class="item-type">{{
                    benefit.benefit_type | capitalize
                  }}</span>
                </div>
              </div>
              <span>{{ benefit.typete }}{{ benefit.discount }}</span>
              <p>{{ benefit.benefit_discount }}</p>
            </div>
          </ng-container>
        </div>

        <ng-container *ngIf="!esCencosud && !esEasy && benefit.redeemCodes">
          <p class="code-title">
            Accedé a tu descuento con el siguiente código
          </p>
          <div class="code-container">
            <p>{{ benefitCode }}</p>
            <img
              (click)="copyCode()"
              src="../../../assets/icon/icon-copy.svg"
            />
            <div
              [ngClass]="this.codeCopied ? 'copy-toast' : 'copy-toast hidden'"
            >
              Copiado al portapapeles!
            </div>
          </div>
          <a
            *ngIf="benefit.benefit_type != 'PRESENCIAL'"
            class="button"
            href="{{ benefit.url }}"
            target="_blank"
            >Ir a la tienda</a
          >
          <div class="see-branches" *ngIf="benefit.benefit_type !== 'ONLINE'">
            <a (click)="toggleBranches()">
              Ver sucursales
              <img
                src="../../../assets/icon/icon-arrow.svg"
                [class.rotate]="showBranches"
                alt="Flecha"
              />
            </a>
          </div>
          <div
            *ngIf="showBranches && benefit.benefit_type !== 'ONLINE'"
            class="branch-list scrollable"
          >
            <div *ngFor="let branch of benefit.branch" class="branch-item">
              <img
                src="../../../assets/icon/icon-local.svg"
                alt="Icono de tienda"
                class="branch-icon"
              />
              <div class="branch-details">
                <p class="branch-name">{{ branch.branch.name }}</p>
                <p class="branch-address">{{ branch.branch.address }}</p>
              </div>
            </div>
          </div>

          <p class="email-text">
            Te enviamos los detalles por correo electrónico.
          </p>
        </ng-container>

        <ng-container *ngIf="esCencosud && benefit.redeemCodes">
          <p class="code-title">
            Accedé a tu descuento presentando el siguiente código en linea de
            caja
          </p>
          <div>
            <img
              [src]="assetUrl('assets/cencosud/barcodeSHEL.jpg')"
              style="height: 120px; width: auto"
            />
          </div>
          <p class="email-text">
            *Te enviamos los detalles a tu correo electrónico.
          </p>
          <a
            *ngIf="benefit.benefit_type != 'PRESENCIAL'"
            class="button"
            href="{{ benefit.url }}"
            target="_blank"
            >Ir a la tienda</a
          >

          <div class="see-branches" *ngIf="benefit.branch.length > 0 &&  benefit.benefit_type !== 'ONLINE'">
            <a (click)="toggleBranches()">
              Ver sucursales
              <img
                src="../../../assets/icon/icon-arrow.svg"
                [class.rotate]="showBranches"
                alt="Flecha"
              />
            </a>
          </div>
          <div
            *ngIf="showBranches && benefit.benefit_type !== 'ONLINE'"
            class="branch-list scrollable"
          >
            <div *ngFor="let branch of benefit.branch" class="branch-item">
              <img
                src="../../../assets/icon/icon-local.svg"
                alt="Icono de tienda"
                class="branch-icon"
              />
              <div class="branch-details">
                <p class="branch-name">{{ branch.branch.name }}</p>
                <p class="branch-address">{{ branch.branch.address }}</p>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="esEasy && benefit.redeemCodes">
          <p class="code-title">
            Accedé a tu descuento presentando el siguiente código en linea de
            caja
          </p>
          <div>
            <img
              [src]="assetUrl('assets/cencosud/barcodeEasy.png')"
              style="height: 120px; width: auto"
            />
          </div>
          <p class="email-text">
            *Te enviamos los detalles a tu correo electrónico.
          </p>
          <a
            *ngIf="benefit.benefit_type != 'PRESENCIAL'"
            class="button"
            href="{{ benefit.url }}"
            target="_blank"
            >Ir a la tienda</a
          >

          <div class="see-branches" *ngIf="benefit.branch.length > 0 && benefit.benefit_type !== 'ONLINE'">
            <a (click)="toggleBranches()">
              Ver sucursales
              <img
                src="../../../assets/icon/icon-arrow.svg"
                [class.rotate]="showBranches"
                alt="Flecha"
              />
            </a>
          </div>
          <div
            *ngIf="showBranches && benefit.benefit_type !== 'ONLINE'"
            class="branch-list scrollable"
          >
            <div *ngFor="let branch of benefit.branch" class="branch-item">
              <img
                src="../../../assets/icon/icon-local.svg"
                alt="Icono de tienda"
                class="branch-icon"
              />
              <div class="branch-details">
                <p class="branch-name">{{ branch.branch.name }}</p>
                <p class="branch-address">{{ branch.branch.address }}</p>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showModalBranches">
    <div class="main-modal-container">
      <div class="modal-box">
        <button
          (click)="this.showModalBranches = false"
          class="close btn-close"
        ></button>
        <div *ngIf="benefit.branch?.length > 0" class="branch-list scrollable" [ngClass]="{ 'showing-branches': showModalBranches }">
          <div *ngFor="let branch of benefit.branch" class="branch-item">
            <img
              src="../../../assets/icon/icon-local.svg"
              alt="Icono de tienda"
              class="branch-icon"
            />
            <div class="branch-details">
              <p class="branch-name">{{ branch.branch.name }}</p>
              <p class="branch-address">{{ branch.branch.address }}</p>
            </div>
          </div>
        </div>
        <div *ngIf="!benefit.branch || benefit.branch.length === 0" class="no-branches-message">
          <p>No hay sucursales disponibles para este beneficio.</p>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div class="slider-container-desktop mb-4">
  <div class="wrapper-container">
    <div class="swiper-wrapper">
      <app-benefits-item
        [customTitle]="'Seguí disfrutando Shell Box'"
        [seeAll]="true"
        [dashboard]="true"
        [benefit]="slidersBenefit"
      ></app-benefits-item>
    </div>
  </div>
</div>
